// import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import defaultProps from 'recompose/defaultProps';
import componentFromProp from 'recompose/componentFromProp';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';

import * as settingsActions from 'app/common/actions/settings/save';

import Settings from '../components/Settings';

/**
* Компонент для вывода настроек
* Можно использовать <SettingsContainer component=AnotherSettingsComponent dataKey="passages" />
* По умолчанию оборачивает <Settings />
* dataKey: редюсер в settings, который отвечает за настройки соответствующего раздела
*/

const enhance = compose(
  defaultProps({ component: Settings }),
  withHandlers({
    handleChangeSettings: props => (obj) => {
      props.actions.saveSettingsKey(props.dataKey, obj);
    },
  })
);
const SettingsContainer = enhance(componentFromProp('component'));


const mapStateToProps = (state, ownProps) => ({
  settings: state.settings[ownProps.dataKey],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(settingsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer);
